
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.367 9.413a2.99 2.99 0 014.22-.001c.581.583.873 1.346.873 2.111 0 .764-.29 1.528-.872 2.11a2.98 2.98 0 01-3.388.574L1.697 25.709a.995.995 0 01-1.406-1.406L11.794 12.8a2.979 2.979 0 01.573-3.387zm2.11 7.083c.55 0 .995.445.995.995v4.56a.994.994 0 11-1.99 0v-4.56c0-.55.445-.995.995-.995zm3.517-1.457a.993.993 0 011.406 0l4.22 4.22a.988.988 0 01.29.704.993.993 0 01-1.698.703l-4.218-4.22a.993.993 0 010-1.407zm-9.485-4.51a.994.994 0 110 1.989H3.95a.994.994 0 110-1.99zm16.497 0a.994.994 0 110 1.989h-4.562a.994.994 0 110-1.99zm-9.826.29a.994.994 0 10-1.405 1.407.994.994 0 001.405-1.407zM5.334 2.381a.993.993 0 011.407 0L10.96 6.6a.992.992 0 010 1.406.993.993 0 01-1.406 0l-4.22-4.219a.993.993 0 010-1.406zm16.879 0a.993.993 0 111.406 1.406L19.4 8.007A.993.993 0 1117.994 6.6zM14.477 0c.55 0 .995.445.995.995v4.56a.994.994 0 11-1.99 0V.996c0-.55.445-.995.995-.995z"}})])
          )
        }
      }
    